import React, { useEffect, useState } from 'react';
import { SearchIcon, FilterIcon, ChevronDownIcon, ChevronUpIcon, GridIcon, ListIcon, RefreshCwIcon, PlusIcon, FolderPlusIcon, UploadIcon, TrashIcon, DownloadIcon, ClockIcon, UserIcon, TagIcon, FolderIcon, FileIcon, MoreHorizontalIcon, XIcon, CheckIcon, AlertTriangleIcon, FileTextIcon, ExternalLinkIcon, EyeIcon, LinkIcon, CalendarIcon, FolderTreeIcon, FileSymlinkIcon, DatabaseIcon, ShieldIcon, CheckCircleIcon, XCircleIcon } from 'lucide-react';
import { FileGrid } from './FileGrid';
import { FileFilters } from './FileFilters';
import { FileDetails } from './FileDetails';
import { FileUpload } from './FileUpload';
import { FileMoveModal } from './FileMoveModal';
import { orgUnitLogoFiles } from '../settings/orgunit/orgUnitLogos';
// Sample files data - now includes org unit logos
const sampleFiles = [...orgUnitLogoFiles, {
  id: 'file-011',
  name: 'Q3_Financial_Report.pdf',
  type: 'pdf',
  size: 1250000,
  uploadDate: '2023-10-15T10:30:00Z',
  lastModified: '2023-10-16T14:20:00Z',
  uploadedBy: 'John Smith',
  status: 'Active',
  department: 'Finance',
  tags: ['financial', 'quarterly', 'report'],
  storageLocation: 's3://company-docs/finance/reports',
  accessLevel: 'Department',
  thumbnailUrl: 'https://templates.invoicehome.com/invoice-template-us-neat-750px.png',
  parentFiles: [{
    id: 'file-015',
    name: 'Financial_Guidelines_2023.pdf'
  }],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-001',
    type: 'Project',
    name: 'Q3 Reporting'
  }]
}, {
  id: 'file-012',
  name: 'Marketing_Campaign_2023.pptx',
  type: 'pptx',
  size: 4580000,
  uploadDate: '2023-10-10T09:15:00Z',
  lastModified: '2023-10-12T11:45:00Z',
  uploadedBy: 'Sarah Johnson',
  status: 'Active',
  department: 'Marketing',
  tags: ['marketing', 'campaign', 'presentation'],
  storageLocation: 's3://company-docs/marketing/campaigns',
  accessLevel: 'Department',
  thumbnailUrl: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [{
    id: 'file-016',
    name: 'Campaign_Images.zip'
  }, {
    id: 'file-017',
    name: 'Campaign_Budget.xlsx'
  }],
  linkedEntities: [{
    id: 'entity-002',
    type: 'Project',
    name: 'Fall Marketing Campaign'
  }, {
    id: 'entity-003',
    type: 'Budget',
    name: 'Marketing Q4 Budget'
  }]
}, {
  id: 'file-013',
  name: 'Employee_Handbook_2023.docx',
  type: 'docx',
  size: 2890000,
  uploadDate: '2023-09-28T14:20:00Z',
  lastModified: '2023-10-05T16:30:00Z',
  uploadedBy: 'Michael Brown',
  status: 'Active',
  department: 'HR',
  tags: ['hr', 'handbook', 'policies'],
  storageLocation: 's3://company-docs/hr/policies',
  accessLevel: 'All Employees',
  thumbnailUrl: 'https://images.unsplash.com/photo-1586281380349-632531db7ed4?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-004',
    type: 'Department',
    name: 'Human Resources'
  }]
}, {
  id: 'file-014',
  name: 'Product_Roadmap_2024.xlsx',
  type: 'xlsx',
  size: 1780000,
  uploadDate: '2023-10-18T11:05:00Z',
  lastModified: '2023-10-18T11:05:00Z',
  uploadedBy: 'David Wilson',
  status: 'Active',
  department: 'Product',
  tags: ['product', 'roadmap', 'planning'],
  storageLocation: 's3://company-docs/product/roadmaps',
  accessLevel: 'Management',
  thumbnailUrl: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-005',
    type: 'Project',
    name: '2024 Product Planning'
  }]
}, {
  id: 'file-015',
  name: 'Financial_Guidelines_2023.pdf',
  type: 'pdf',
  size: 3450000,
  uploadDate: '2023-09-15T13:45:00Z',
  lastModified: '2023-09-15T13:45:00Z',
  uploadedBy: 'Jennifer Lee',
  status: 'Active',
  department: 'Finance',
  tags: ['financial', 'guidelines', 'compliance'],
  storageLocation: 's3://company-docs/finance/guidelines',
  accessLevel: 'Department',
  thumbnailUrl: 'https://templates.invoicehome.com/invoice-template-us-classic-white-750px.png',
  parentFiles: [],
  childFiles: [{
    id: 'file-011',
    name: 'Q3_Financial_Report.pdf'
  }],
  linkedEntities: [{
    id: 'entity-006',
    type: 'Department',
    name: 'Finance'
  }]
}, {
  id: 'file-016',
  name: 'Campaign_Images.zip',
  type: 'zip',
  size: 25600000,
  uploadDate: '2023-10-08T10:30:00Z',
  lastModified: '2023-10-08T10:30:00Z',
  uploadedBy: 'Sarah Johnson',
  status: 'Active',
  department: 'Marketing',
  tags: ['marketing', 'campaign', 'images'],
  storageLocation: 's3://company-docs/marketing/assets',
  accessLevel: 'Department',
  thumbnailUrl: 'https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=400&h=300&fit=crop',
  parentFiles: [{
    id: 'file-012',
    name: 'Marketing_Campaign_2023.pptx'
  }],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-002',
    type: 'Project',
    name: 'Fall Marketing Campaign'
  }]
}, {
  id: 'file-017',
  name: 'Campaign_Budget.xlsx',
  type: 'xlsx',
  size: 980000,
  uploadDate: '2023-10-09T14:15:00Z',
  lastModified: '2023-10-11T09:20:00Z',
  uploadedBy: 'Sarah Johnson',
  status: 'Active',
  department: 'Marketing',
  tags: ['marketing', 'campaign', 'budget'],
  storageLocation: 's3://company-docs/marketing/budgets',
  accessLevel: 'Department',
  thumbnailUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
  parentFiles: [{
    id: 'file-012',
    name: 'Marketing_Campaign_2023.pptx'
  }],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-002',
    type: 'Project',
    name: 'Fall Marketing Campaign'
  }, {
    id: 'entity-003',
    type: 'Budget',
    name: 'Marketing Q4 Budget'
  }]
}, {
  id: 'file-018',
  name: 'IT_Security_Protocols.pdf',
  type: 'pdf',
  size: 4120000,
  uploadDate: '2023-09-20T08:45:00Z',
  lastModified: '2023-10-01T11:30:00Z',
  uploadedBy: 'Robert Taylor',
  status: 'Active',
  department: 'IT',
  tags: ['it', 'security', 'protocols'],
  storageLocation: 's3://company-docs/it/security',
  accessLevel: 'Restricted',
  thumbnailUrl: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-007',
    type: 'Department',
    name: 'IT'
  }, {
    id: 'entity-008',
    type: 'Policy',
    name: 'Information Security Policy'
  }]
}, {
  id: 'file-019',
  name: 'Customer_Feedback_Q3.xlsx',
  type: 'xlsx',
  size: 2340000,
  uploadDate: '2023-10-05T15:20:00Z',
  lastModified: '2023-10-07T09:10:00Z',
  uploadedBy: 'Amanda Clark',
  status: 'Active',
  department: 'Customer Support',
  tags: ['customer', 'feedback', 'quarterly'],
  storageLocation: 's3://company-docs/customer-support/feedback',
  accessLevel: 'Department',
  thumbnailUrl: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-009',
    type: 'Department',
    name: 'Customer Support'
  }, {
    id: 'entity-010',
    type: 'Report',
    name: 'Q3 Customer Satisfaction'
  }]
}, {
  id: 'file-020',
  name: 'Board_Meeting_Minutes_Oct2023.docx',
  type: 'docx',
  size: 1560000,
  uploadDate: '2023-10-20T16:45:00Z',
  lastModified: '2023-10-21T10:15:00Z',
  uploadedBy: 'Charles Martin',
  status: 'Active',
  department: 'Executive',
  tags: ['board', 'meeting', 'minutes'],
  storageLocation: 's3://company-docs/executive/board',
  accessLevel: 'Executive',
  thumbnailUrl: 'https://images.unsplash.com/photo-1568667256549-094345857637?w=400&h=300&fit=crop',
  parentFiles: [],
  childFiles: [],
  linkedEntities: [{
    id: 'entity-011',
    type: 'Meeting',
    name: 'October Board Meeting'
  }]
}];
export function FileLibrary({
  locale = 'en-US'
}) {
  const [files, setFiles] = useState(sampleFiles);
  const [filteredFiles, setFilteredFiles] = useState(sampleFiles);
  const [selectedFile, setSelectedFile] = useState(null);
  const [showDetails, setShowDetails] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showAdvancedFilters, setShowAdvancedFilters] = useState(true);
  const [isAdminView, setIsAdminView] = useState(false);
  const [viewMode, setViewMode] = useState('list'); // 'list' or 'grid'
  const [showMoveFileModal, setShowMoveFileModal] = useState(false);
  const [fileToMove, setFileToMove] = useState(null);
  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  // Calculate total pages whenever filtered files change
  useEffect(() => {
    setTotalPages(Math.ceil(filteredFiles.length / pageSize));
    // Reset to first page when filters change the file set
    setCurrentPage(1);
  }, [filteredFiles, pageSize]);
  // Get current page files
  const getCurrentPageFiles = () => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return filteredFiles.slice(startIndex, endIndex);
  };
  // Handle file selection
  const handleFileSelect = file => {
    setSelectedFile(file);
    setShowDetails(true);
  };
  // Handle file download
  const handleDownload = fileId => {
    // In a real app, this would trigger a download of the file
    alert(`Downloading file with ID: ${fileId}`);
  };
  // Handle filter changes
  const handleFilterChange = filters => {
    setIsLoading(true);
    // Simulate API call delay
    setTimeout(() => {
      let result = [...files];
      // Apply filters
      if (filters.search) {
        const searchLower = filters.search.toLowerCase();
        result = result.filter(file => file.name.toLowerCase().includes(searchLower) || file.uploadedBy.toLowerCase().includes(searchLower) || file.department && file.department.toLowerCase().includes(searchLower) || file.tags && file.tags.some(tag => tag.toLowerCase().includes(searchLower)));
      }
      if (filters.fileType && filters.fileType !== 'all') {
        result = result.filter(file => file.type === filters.fileType);
      }
      if (filters.department && filters.department !== 'all') {
        result = result.filter(file => file.department === filters.department);
      }
      if (filters.dateRange) {
        const now = new Date();
        let startDate = new Date();
        if (filters.dateRange === 'last7days') {
          startDate.setDate(now.getDate() - 7);
        } else if (filters.dateRange === 'last30days') {
          startDate.setDate(now.getDate() - 30);
        } else if (filters.dateRange === 'last90days') {
          startDate.setDate(now.getDate() - 90);
        } else if (filters.dateRange === 'custom') {
          startDate = new Date(filters.startDate);
          const endDate = new Date(filters.endDate);
          endDate.setHours(23, 59, 59, 999); // End of day
          result = result.filter(file => {
            const fileDate = new Date(file.uploadDate);
            return fileDate >= startDate && fileDate <= endDate;
          });
          setFilteredFiles(result);
          setIsLoading(false);
          return;
        }
        result = result.filter(file => new Date(file.uploadDate) >= startDate);
      }
      if (filters.uploadedBy && filters.uploadedBy !== 'all') {
        result = result.filter(file => file.uploadedBy === filters.uploadedBy);
      }
      if (filters.tags && filters.tags.length > 0) {
        result = result.filter(file => file.tags && filters.tags.every(tag => file.tags.includes(tag)));
      }
      if (filters.status && filters.status !== 'all') {
        result = result.filter(file => file.status === filters.status);
      }
      setFilteredFiles(result);
      setIsLoading(false);
    }, 500);
  };
  // Format file size
  const formatFileSize = bytes => {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  // Handle page change
  const handlePageChange = page => {
    setCurrentPage(page);
  };
  // Handle move file
  const handleMoveFile = file => {
    setFileToMove(file);
    setShowMoveFileModal(true);
  };
  // Handle view mode change
  const handleViewModeChange = mode => {
    setViewMode(mode);
  };
  // Handle admin view toggle
  const handleAdminViewToggle = () => {
    setIsAdminView(!isAdminView);
  };
  // Get the current files to display
  const currentFiles = getCurrentPageFiles();
  return <div className="mb-8" data-id="element-5269">
      <div className="flex justify-between items-center mb-6" data-id="element-5270">
        <div data-id="element-5271">
          <h2 className="text-2xl font-bold text-gray-900" data-id="element-5272">File Library</h2>
          <p className="mt-1 text-sm text-gray-500" data-id="element-5273">
            Browse, search, and manage all files in the system
          </p>
        </div>
        <div className="flex space-x-2" data-id="element-5274">
          <button onClick={() => setShowAdvancedFilters(!showAdvancedFilters)} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-5275">
            <FilterIcon className="h-4 w-4 mr-1" data-id="element-5276" />
            {showAdvancedFilters ? 'Hide Filters' : 'Show Filters'}
          </button>
          <div className="flex border border-gray-300 rounded-md overflow-hidden" data-id="element-5277">
            <button onClick={() => handleViewModeChange('list')} className={`inline-flex items-center px-3 py-2 text-sm leading-4 font-medium ${viewMode === 'list' ? 'bg-indigo-100 text-indigo-700' : 'bg-white text-gray-700 hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`} data-id="element-5278">
              <ListIcon className="h-4 w-4" data-id="element-5279" />
            </button>
            <button onClick={() => handleViewModeChange('grid')} className={`inline-flex items-center px-3 py-2 text-sm leading-4 font-medium ${viewMode === 'grid' ? 'bg-indigo-100 text-indigo-700' : 'bg-white text-gray-700 hover:bg-gray-50'} focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`} data-id="element-5280">
              <GridIcon className="h-4 w-4" data-id="element-5281" />
            </button>
          </div>
          <button onClick={handleAdminViewToggle} className={`inline-flex items-center px-3 py-2 border shadow-sm text-sm leading-4 font-medium rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 ${isAdminView ? 'border-indigo-500 text-indigo-700 bg-indigo-50 hover:bg-indigo-100' : 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50'}`} data-id="element-5282">
            <DatabaseIcon className="h-4 w-4 mr-1" data-id="element-5283" />
            Admin View
          </button>
          <button className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" data-id="element-5284">
            <UploadIcon className="h-4 w-4 mr-1" data-id="element-5285" />
            Upload
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-6" data-id="element-5286">
        {showAdvancedFilters && <FileFilters onFilterChange={handleFilterChange} locale={locale} isAdminView={isAdminView} data-id="element-5287" />}
        <div className="bg-white shadow overflow-hidden sm:rounded-lg" data-id="element-5288">
          <div className="flex justify-between items-center px-4 py-3 border-b border-gray-200" data-id="element-5289">
            <div className="text-sm text-gray-500" data-id="element-5290">
              Showing{' '}
              <span className="font-medium" data-id="element-5291">
                {Math.min(pageSize, filteredFiles.length - (currentPage - 1) * pageSize)}
              </span>{' '}
              of <span className="font-medium" data-id="element-5292">{filteredFiles.length}</span>{' '}
              files
            </div>
            <div className="flex space-x-2" data-id="element-5293">
              <button onClick={() => handleFilterChange({})} className="inline-flex items-center px-2 py-1 border border-gray-300 text-xs font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none" data-id="element-5294">
                <RefreshCwIcon className="h-3 w-3 mr-1" data-id="element-5295" />
                Reset
              </button>
            </div>
          </div>
          <FileGrid files={currentFiles} onFileSelect={handleFileSelect} onDownload={handleDownload} isLoading={isLoading} locale={locale} isAdminView={isAdminView} viewMode={viewMode} formatFileSize={formatFileSize} data-id="element-5296" />
          {/* Pagination */}
          {totalPages > 1 && <div className="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6" data-id="element-5297">
              <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between" data-id="element-5298">
                <div data-id="element-5299">
                  <p className="text-sm text-gray-700" data-id="element-5300">
                    Showing{' '}
                    <span className="font-medium" data-id="element-5301">
                      {(currentPage - 1) * pageSize + 1}
                    </span>{' '}
                    to{' '}
                    <span className="font-medium" data-id="element-5302">
                      {Math.min(currentPage * pageSize, filteredFiles.length)}
                    </span>{' '}
                    of{' '}
                    <span className="font-medium" data-id="element-5303">{filteredFiles.length}</span>{' '}
                    results
                  </p>
                </div>
                <div data-id="element-5304">
                  <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination" data-id="element-5305">
                    <button onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1} className={`relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium ${currentPage === 1 ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5306">
                      <span className="sr-only" data-id="element-5307">Previous</span>
                      <ChevronDownIcon className="h-5 w-5 rotate-90" data-id="element-5308" />
                    </button>
                    {[...Array(totalPages)].map((_, i) => <button key={i} onClick={() => handlePageChange(i + 1)} className={`relative inline-flex items-center px-4 py-2 border text-sm font-medium ${currentPage === i + 1 ? 'z-10 bg-indigo-50 border-indigo-500 text-indigo-600' : 'bg-white border-gray-300 text-gray-500 hover:bg-gray-50'}`} data-id="element-5309">
                        {i + 1}
                      </button>)}
                    <button onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages} className={`relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium ${currentPage === totalPages ? 'text-gray-300 cursor-not-allowed' : 'text-gray-500 hover:bg-gray-50'}`} data-id="element-5310">
                      <span className="sr-only" data-id="element-5311">Next</span>
                      <ChevronUpIcon className="h-5 w-5 rotate-90" data-id="element-5312" />
                    </button>
                  </nav>
                </div>
              </div>
            </div>}
        </div>
      </div>
      {/* File Details Sidebar */}
      {showDetails && selectedFile && <div className="fixed inset-0 overflow-hidden z-20" data-id="element-5313">
          <div className="absolute inset-0 overflow-hidden" data-id="element-5314">
            <div className="absolute inset-0 bg-gray-500 bg-opacity-75 transition-opacity" onClick={() => setShowDetails(false)} data-id="element-5315"></div>
            <section className="absolute inset-y-0 right-0 pl-10 max-w-full flex" data-id="element-5316">
              <div className="relative w-screen max-w-md" data-id="element-5317">
                <div className="h-full flex flex-col py-6 bg-white shadow-xl overflow-y-auto" data-id="element-5318">
                  <div className="px-4 sm:px-6" data-id="element-5319">
                    <div className="flex items-start justify-between" data-id="element-5320">
                      <h2 id="slide-over-heading" className="text-lg font-medium text-gray-900" data-id="element-5321">
                        File Details
                      </h2>
                      <div className="ml-3 h-7 flex items-center" data-id="element-5322">
                        <button onClick={() => setShowDetails(false)} className="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500" data-id="element-5323">
                          <span className="sr-only" data-id="element-5324">Close panel</span>
                          <XIcon className="h-6 w-6" data-id="element-5325" />
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="mt-6 relative flex-1 px-4 sm:px-6" data-id="element-5326">
                    <FileDetails file={selectedFile} onClose={() => setShowDetails(false)} onDownload={handleDownload} onMove={handleMoveFile} formatFileSize={formatFileSize} locale={locale} data-id="element-5327" />
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>}
      {/* File Move Modal */}
      {showMoveFileModal && fileToMove && <FileMoveModal file={fileToMove} isOpen={showMoveFileModal} onClose={() => setShowMoveFileModal(false)} onMove={destination => {
      // In a real app, this would update the file's location
      alert(`Moving file ${fileToMove.name} to ${destination}. This would update the file's location in a real application.`);
      setShowMoveFileModal(false);
    }} data-id="element-5328" />}
    </div>;
}